import { SuperInput } from "@components:SuperInput/SuperInput";
import { Toggle } from "@components:Toggle";
import { useDebounce } from "@hooks:useDebounce";
import { Box, InputAdornment } from "@mui/material";
import Button from "@mui/material/Button";
import { Header } from "@pages:settings/Header";
import { BotModal } from "@pages:settings/Tenent/Bots/BotModal";
import { BotsTable } from "@pages:settings/Tenent/Bots/BotsTable";
import { useBotsActions, useBotsData } from "@stores:settings/bots";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoMdSearch } from "react-icons/io";
import { MdClear, MdDomainAdd } from "react-icons/md";

export const Bots = () => {
  const { t } = useTranslation();
  const states = [
    {
      label: t("common.active"),
      value: "active",
    },
    {
      label: t("common.inactive"),
      value: "inactive",
    },
  ];
  const { searchKeyword, state } = useBotsData();
  const { setSearchKeyword, setState, unMount } = useBotsActions();
  const [isOpenModalToCreate, setIsOpenModalToCreate] = useState(false);
  const [searchKey, setSearchKey] = useState("");

  useEffect(() => {
    return () => {
      unMount();
    };
  }, [unMount]);

  const onChange = () => {
    setSearchKeyword(searchKey);
  };

  const debouncedOnChange = useDebounce(onChange);

  return (
    <Box
      className="Settings__Bots"
      sx={{
        width: "100%",
        height: "100%",
        overflowY: "hidden",
        overflowX: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header
        leftSide={
          <Toggle state={state} allState={states} setState={setState} />
        }
        rightSide={
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Button
              variant="outlined"
              startIcon={<MdDomainAdd />}
              onClick={() => {
                setIsOpenModalToCreate(true);
              }}
            >
              {t("tenant.bots.add")}
            </Button>
            <SuperInput.TextField
              autoHeight={false}
              placeholder={t("tenant.bots.searchPlaceholder")}
              value={searchKey}
              onChange={(e) => {
                debouncedOnChange();
                setSearchKey(e.target.value);
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{
                        backgroundColor: "transparent",
                      }}
                    >
                      <IoMdSearch size={20} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{
                        cursor: "pointer",
                        visibility: searchKeyword ? "visible" : "hidden",
                      }}
                      onClick={() => {
                        debouncedOnChange();
                        setSearchKey("");
                      }}
                    >
                      <MdClear size={20} />
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Box>
        }
      />
      <Box
        sx={{
          flex: 1,
          minHeight: "0",
          pt: "2.5rem",
          px: "2.5rem",
        }}
      >
        <BotsTable />
      </Box>
      {isOpenModalToCreate && (
        <BotModal
          isOpen={isOpenModalToCreate}
          onClose={() => setIsOpenModalToCreate(false)}
        />
      )}
    </Box>
  );
};
